/** Shared Order Entry tab field keys (must match API defaults). */
export const ORDER_ENTRY_TAB_FIELDS = [
  { fieldKey: 'voucherNo', label: 'Voucher No', tabOrder: 10 },
  { fieldKey: 'storeRefNo', label: 'Ref No / Store Ref', tabOrder: 20 },
  { fieldKey: 'pickUpBy', label: 'Pick Up By', tabOrder: 30 },
  { fieldKey: 'payType', label: 'Pay Type', tabOrder: 40 },
  { fieldKey: 'chargeFrom', label: 'Charge From', tabOrder: 50 },
  { fieldKey: 'clientBillNo', label: 'Client Bill No', tabOrder: 60 },
  { fieldKey: 'type', label: 'Type', tabOrder: 70 },
  { fieldKey: 'agent', label: 'Agent', tabOrder: 80 },
  { fieldKey: 'forPickup', label: 'For Pickup', tabOrder: 90 },
  { fieldKey: 'exchange', label: 'Exchange', tabOrder: 100 },
  { fieldKey: 'fragile', label: 'Fragile', tabOrder: 110 },

  { fieldKey: 'clientName', label: 'Client Name', tabOrder: 200 },
  { fieldKey: 'clientNo', label: 'Client No', tabOrder: 210 },
  { fieldKey: 'clientMobile', label: 'Client Mobile', tabOrder: 220 },
  { fieldKey: 'clientEmirate', label: 'Client Emirate', tabOrder: 230 },
  { fieldKey: 'clientLocation', label: 'Client Location', tabOrder: 240 },
  { fieldKey: 'clientLocationUrl', label: 'Client Location URL', tabOrder: 250 },
  { fieldKey: 'clientAddress', label: 'Client Address', tabOrder: 260 },
  { fieldKey: 'clientPoBox', label: 'Client PO Box', tabOrder: 270 },

  { fieldKey: 'customerName', label: 'Customer Name', tabOrder: 300 },
  { fieldKey: 'customerMobile1', label: 'Customer Mobile 1', tabOrder: 310 },
  { fieldKey: 'customerMobile2', label: 'Customer Mobile 2', tabOrder: 320 },
  { fieldKey: 'customerEmirate', label: 'Customer Emirate', tabOrder: 330 },
  { fieldKey: 'customerLocation', label: 'Customer Location', tabOrder: 340 },
  { fieldKey: 'customerLocationUrl', label: 'Customer Location URL', tabOrder: 350 },
  { fieldKey: 'customerAddress', label: 'Customer Address', tabOrder: 360 },
  { fieldKey: 'customerPoBox', label: 'Customer PO Box', tabOrder: 370 },

  { fieldKey: 'remarks', label: 'Remarks', tabOrder: 400 },
  { fieldKey: 'quantity', label: 'Quantity', tabOrder: 410 },
  { fieldKey: 'pickupDate', label: 'Pickup Date', tabOrder: 420 },
  { fieldKey: 'deliveryDate', label: 'Delivery Date', tabOrder: 430 },
  { fieldKey: 'productPrice', label: 'Product Price', tabOrder: 440 },
  { fieldKey: 'deliveryCharge', label: 'Delivery Charge', tabOrder: 450 },
];

export function buildSkippedFieldSet(settings) {
  const set = new Set();
  if (!Array.isArray(settings)) return set;
  settings.forEach((row) => {
    if (row?.IsSkipped && row?.FieldKey) set.add(row.FieldKey);
  });
  return set;
}

/** Returns -1 when field should be skipped on Tab; otherwise undefined (browser default). */
export function orderEntryTabIndex(skippedSet, fieldKey) {
  if (skippedSet && skippedSet.has(fieldKey)) return -1;
  return undefined;
}
